import { incomingCPPostMessages } from '../consts';

export const isCPPostMessage = (message) =>
  Object.values(incomingCPPostMessages).includes(message);
